import AboutHome from "../../components/AboutHome/AboutHome";
import HeroSection from "../../components/Home-one/HomeOne";
import Produtos from "../../components/Produtos/Produtos";
import ProcessSection from "../../components/ProcessSection/ProcessSection";

export function HomeScreen() {
  return (
    <>
      <HeroSection />
      <Produtos />
      <AboutHome />
      <ProcessSection />
    </>
  );
}
